import axios, { AxiosResponse } from "axios";
import { isDemo } from "@/utils";
import { ShortlinkReportPayload } from "@/models/Shortlink";
import { convertCamelToSnake, getApiEndpoints } from "@/utils/utils";

let instance: ReportService = null;

class ReportService {
    async createReport(properties: ShortlinkReportPayload) {
        if (isDemo()) {
            return Promise.resolve();
        }

        try {
            const convertedProperties = convertCamelToSnake(properties);
            const fd = new FormData();
            Object.entries(convertCamelToSnake(convertedProperties)).forEach(([key, value]) => {
                fd.append(key, value as string);
            });
            const response: AxiosResponse = await axios.post(getApiEndpoints().SHORTLINK_REPORTS, fd);
            return response;
        } catch (e) {
            if (e?.response?.data) {
                return e.response.data;
            }

            return null;
        }
    }
}

export default function getInstance(): ReportService {
    if (!instance) {
        instance = new ReportService();
    }

    return instance;
}
